import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetenergycostspage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetEnergyCostsPage } = await import(
        /* webpackChunkName: "Login" */ '../../../components/pages/private/BudgetEnergyCostsPage'
      )
      return {
        default: BudgetEnergyCostsPage,
      }
    })}
    exact
    key={paths.energyCostsImport}
    path={paths.energyCostsImport}
  />,
]
